import { CityType } from './constants';

export const getCityTypeLabel = (t, type) => {
  switch (type) {
    case CityType.Country:
      return t('City.Country');
    case CityType.District:
      return t('City.District');
    case CityType.Town:
      return t('City.City');
    default:
      return;
  }
};

export const getCityTypeIcon = type => {
  switch (type) {
    case CityType.Country:
      return 'flag';
    case CityType.District:
      return 'landscape';
    case CityType.Town:
      return 'location_city';
    default:
      return;
  }
};

export const getActionsSlotId = () => `actions-slot-${crypto.randomUUID()}`;
